query GetIntelligentDeliveryApiInfo {
    intelligentDeliveryApiInfo {
        url
    }
}
